import {IntermediatePart} from "../../intermediatePart";
import {LOOK_ROOM_TYPES, SIDE_POSITIONS} from "../../constants";
import {removeLookPointFor} from "../../../lookNavigation/lookFunctions2";
import {getCurrentRoomType} from "../../../../appLayout";

export default class TowelRing extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'towel_ring';
    this.partName = 'Towel Ring';
    this.translateId = "visualizer.bathroom.accessories.towel_ring";
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [SIDE_POSITIONS[0]]: null,
        [SIDE_POSITIONS[1]]: null,
      };
    }
  }

  load(dbFeature) {
    dbFeature.lixilProductSubCategory = "Towel Rings"; // hardcode to match other towel rings // LX-846
    dbFeature.thirdPartyProductCategory = "Towel Rings"; // hardcode to match other towel rings // LX-846
    return super.load(dbFeature);
  }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return removeLookPointFor(parentObject, 6, "1", SIDE_POSITIONS[1])
    }
    return removeLookPointFor(parentObject, 3, "2", SIDE_POSITIONS[1])
      && removeLookPointFor(parentObject, 1, "1", SIDE_POSITIONS[1])
  }
}
